module.exports = __webpack_public_path__ + "static/SY-testing-8b3e5447b0e363d612f510c56bd0bc5e.png";